import { render } from "./TestimonialSection.vue?vue&type=template&id=c1809fde&scoped=true"
import script from "./TestimonialSection.vue?vue&type=script&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&lang=js"

import "./TestimonialSection.vue?vue&type=style&index=0&id=c1809fde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1809fde"]])

export default __exports__